import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import React from "react";
import XCloseIco from "../../../../assets/icons/XCloseIco";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonTippy } from "../../style";
import CommonButton from "../../../../component/Button";

const DialogCandidateHub = ({
  handleButttonClose,
  open,
  handleClose,
  footer,
  content,
  title,
  icon,
  closeIcon = true,
  disabled = false,
  titlepadding,
  centerIcon,
  maxWidth,
  customStyle,
  minWidth,
}) => {
  return (
    <Dialog
      fullWidth
      maxWidth={maxWidth || "xs"}
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "10px",
          minWidth: minWidth,
        },
      }}
    >
      {closeIcon && (
        <DialogActions sx={{ justifyContent: "space-between" }}>
          <CustomDiv>{icon}</CustomDiv>
          <CommonTippy
            content={"Button is disabled"}
            placement="top"
            disabled={!disabled}
            color="#7F56D9"
            fontWeight={600}
            fontSize={"13px"}
          >
            <CustomDiv>
              {/* <CommonButton
                onClick={handleButttonClose || handleClose}
                padding={"10px"}
                background={"rgba(127, 86, 217, 0.04)"}
                border="rgba(127, 86, 217, 0.5)"
                height={"100%"}
                value={<XCloseIco />}
                boxShadow="0px 0px 10px 0px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 4px 0px rgba(0,0,0,0.12)"
                disabled={disabled}
                customStyle={{ top: icon ? "-10px" : "0px", ...customStyle }}
              /> */}
              <Button
                onClick={handleButttonClose || handleClose}
                disabled={disabled}
              >
                <XCloseIco />
              </Button>
            </CustomDiv>
          </CommonTippy>
        </DialogActions>
      )}

      <DialogContent
        style={{ textAlign: "center", paddingTop: "0px", overflowY: "initial" }}
      >
        {centerIcon}
        {title && (
          <Typography variant="h3" textAlign={"center"} padding={titlepadding}>
            {title}
          </Typography>
        )}
        <Typography variant="p" fontSize={"15px"}>
          {content}
        </Typography>

        {footer}
      </DialogContent>
    </Dialog>
  );
};

export default DialogCandidateHub;
